import { Flex, styled } from '@cad-arc';
import { DEFAULT_COL_MIN_HEIGHT } from './constants';

export const BaseCellStyledBox = styled(Flex)<{
    $padding?: string | number;
    $alignItems?: string;
    $justifyContent?: string;
    $fontSize?: string;
}>`
    padding: ${(props) => props.$padding ?? '5px 15px 5px 10px'};
    width: 100%;
    align-items: ${(props) => props.$alignItems ?? 'center'};
    justify-content: ${(props) => props.$justifyContent ?? 'start'};
    font-size: ${(props) => props.$fontSize ?? '18px'};
    line-height: 1.2;
    height: 100%;
    min-height: ${DEFAULT_COL_MIN_HEIGHT}px;
    overflow: hidden;
    text-transform: uppercase;
`;
